module.exports = __webpack_public_path__ + "images/interview-Nike-2.svg";